// http
import Axios from 'axios'
export default {
  //请求基础路径
  API_ROOT: function () {
        // http://api.testing.nczxhx.com/cgi/business/banner/home
    if (process.env.NODE_ENV === 'production') {
       if(document.location.protocol=='https:'){
        return 'https://zsyteapi.zhixinhuixue.com/cgi/'
       }else{
        return 'http://zsycgi.zhixinhuixue.com/cgi/';
       }
    } else if (process.env.NODE_ENV === 'testing') {
      return 'http://api.testing.nczxhx.com/cgi/';
      // return 'http://zsy.dev.xueping.com/cgi/';
    } else {
      return 'http://api.testing.nczxhx.com/cgi/';
      // return 'http://zsy.dev.xueping.com/cgi/';
    }
  },
  // TEACHER_API_ROOT: function () {
  //   if (process.env.NODE_ENV === 'production') {
  //     return 'http://zsyte2.zhixinhuixue.com/teacher/';
  //   } else if (process.env.NODE_ENV === 'testing') {
  //     return 'http://zsy.dev.xueping.com/teacher/';
  //   } else {
  //     return 'http://zsy.dev.xueping.com/teacher/';
  //   }
  // },
  SIGN_NAME_API_ROOT: function () {
    if (process.env.NODE_ENV === 'production') {
      return 'http://zsyapi.zhixinhuixue.com';
    } else if (process.env.NODE_ENV === 'testing') {
      return 'http://api.testing.nczxhx.com/cgi/';
    } else {
      return 'http://api.testing.nczxhx.com/cgi/';
      // return 'http://zxhx:533166afe82356ff5bc22ae9a263fb4e@zsyapi.dev.xueping.com';
      // return 'http://192.168.1.105:105';
    }
  },
  //联考报名
  SIGN_UP_API_ROOT: function () {
    if (process.env.NODE_ENV === 'production') {
      return 'http://zsyapi.zhixinhuixue.com';
    } else if (process.env.NODE_ENV === 'testing') {
      return 'http://zsyapi.testing.nczxhx.com';
    } else {
      return 'http://zsyapi.testing.nczxhx.com';
      // return 'http://zxhx:533166afe82356ff5bc22ae9a263fb4e@zsyapi.dev.xueping.com';
      // return 'http://192.168.1.105:105';
    }
  },
// production: http://zsyhm.zhixinhuixue.com/#/token/
// testing: http://zsyhm.dev.xueping.com/#/token/
// dev: http://zsyhm.dev.xueping.com/#/token/
  // 校长端登录成功跳转
  JUMP_URL: function () {
    let url = {};
    if (process.env.NODE_ENV === 'production') {
      url.hm = 'http://zsyhm2.zhixinhuixue.com';
    } else if (process.env.NODE_ENV === 'testing') {
      url.hm = 'http://zsyhm2.dev.xueping.com';
    } else {
      url.hm = 'http://zsyhm2.dev.xueping.com';
    }
    return url;
  },
  JUMP_TEACHER_URL: function () {
    let url = {};
    if (process.env.NODE_ENV === 'production') {
      url.hm = 'http://zsyte.zhixinhuixue.com';
    } else if (process.env.NODE_ENV === 'testing') {
      url.hm = 'http://zsyte.testing.nczxhx.com';
    } else {
      url.hm = 'http://zsyte.dev.xueping.com';
    }
    return url;
  },
//   production: http://zsyst.zhixinhuixue.com/index?token=
// testing: http://zsyst2hd.dev.xueping.com/index?token=
// dev: http://zsyst2hd.dev.xueping.com/index?token=
  JUMP_STUDENT_URL: function () {
    let url = {};
    if (process.env.NODE_ENV === 'production') {
      url.hm = 'http://zsyst.zhixinhuixue.com';
    } else if (process.env.NODE_ENV === 'dev') {
      url.hm = 'http://zsyst2hd.dev.xueping.com';
    } else {
      url.hm = 'http://zsyst2hd.testing.nczxhx.com';
    }
    return url;
  },
  //请求方法
  HTTP_METHOD: {
    GET: "get",
    POST: "post",
    PUT: "put",
    DELETE: "delete"
  },
  //请求超时时间15s
  TIME_OUT: 15000,
  //返回数据类型JSON
  RESPONSE_TYPE: 'json',

  //AXIOS请求
  zsyHttpBase(_url, _method, _data = {}, success, fail, _catch) {
    let _this = this;
    //请求全局配置
    let config = {};

    config.baseURL = _this.API_ROOT();
    config.url = _url;
    if (_method && _method == _this.HTTP_METHOD.GET) {
      config.params = _data;
    } else if (_method && (_method == _this.HTTP_METHOD.POST
      || _method == _this.HTTP_METHOD.PUT)) {
      config.data = _data;
    }
    config.method = _method;
    config.timeout = _this.TIME_OUT;
    config.responseType = _this.RESPONSE_TYPE;
    if(window.localStorage.getItem("token")){
      config.headers = { 'Authorization': "Bearer " + window.localStorage.getItem("token") };
    }
    Axios(config).then((response) => {
      let res = response.data;
      if (res.errCode != "00") {
        if (res.errCode == "02") {
          //重新登录
          Message.warning(res.errMsg);
          setTimeout(function () {
            window.vue.$router.push("/");
            window.localStorage.clear();
          }, 1000);
        } else {
          if (typeof fail == "function") {
            fail(res);
          } else {
            if (res.errMsg != "") {
              Message.error(res.errMsg);
            }
          }
        }
      } else {
        success && success(res);
      }
      ;
    }).catch((err) => {
      _catch && _catch(err);
      if (err.message.indexOf("Network Error") != -1) {
        // Message.error('网络异常,请检查您的网络连接,请稍后重试.');
      } else if (err.message.indexOf("timeout") != -1) {
        // Message.error('当前网络连接不给力，请稍后重试.');
      } else if (err.message.indexOf("code 503") != -1) {
        // Message.error('当前服务不可用');
      } else {
        // Message.error('系统异常');
      }
    })
  },
  // GET请求
  zsyGetHttp(_url, _data = {}, success, fail, _catch) {
    let _this = this;
    _this.zsyHttpBase(_url, _this.HTTP_METHOD.GET, _data, success, fail, _catch);
  },
  // POST请求
  zsyPostHttp(_url, _data = {}, success, fail, _catch) {
    let _this = this;
    _this.zsyHttpBase(_url, _this.HTTP_METHOD.POST, _data, success, fail, _catch);
  },
  // PUT请求
  zsyPutHttp(_url, _data = {}, success, fail, _catch) {
    let _this = this;
    _this.zsyHttpBase(_url, _this.HTTP_METHOD.PUT, _data, success, fail, _catch);
  },
  // DELETE请求
  zsyDeleteHttp(_url, _data = {}, success, fail, _catch) {
    let _this = this;
    _this.zsyHttpBase(_url, _this.HTTP_METHOD.DELETE, _data, success, fail, _catch);
  },
  Axios: Axios
}



// WEBPACK FOOTER //
// ./src/lib/Http.js